import { Loader2 } from "lucide-react";
import type { ViewEntityType } from "@colab/shared";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { useDeleteView } from "@/features/admin/views/use-delete-view";

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  viewId: string;
  entityType: ViewEntityType;
  viewName: string;
};

export function DeleteViewDialog({
  open,
  onOpenChange,
  viewId,
  entityType,
  viewName,
}: Props) {
  const deleteView = useDeleteView();

  function confirm() {
    deleteView.mutate(
      { id: viewId, entityType },
      {
        onSuccess: () => onOpenChange(false),
      },
    );
  }

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="font-display tracking-tight">
            Delete view “{viewName}”?
          </AlertDialogTitle>
          <AlertDialogDescription>
            The tab disappears for every viewer with access. Filter
            definitions cannot be recovered.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={deleteView.isPending}>
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction
            disabled={deleteView.isPending}
            onClick={confirm}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            {deleteView.isPending && (
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            )}
            Delete
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
